// extracted by mini-css-extract-plugin
export default {"link":"_1HnJ6","tanakLink":"_2OYDZ","container":"_2dJqc","hyphen":"_3jpO-","lastItemGroup":"_2L7t8","selected":"_1hzVn","tanakSelected":"_3MmAw"};